import { makeRequest } from "./makeRequest";
import LocalstorageService from "../services/localStorageService";

export function makeRequestWithLanguage(api, url, options) {
  const language = LocalstorageService.getLanguage();
  const concatSign = url.includes("?") ? "&" : "?";
  const preparedUrl = `${url}${concatSign}language=${language}`;
  return makeRequest(api, preparedUrl, options);
}
